(function () {
  const root = document.querySelector('[data-article-section]');
  if (!root) return;

  root.querySelectorAll('.article-content p').forEach((paragraph) => {
    if (paragraph.closest('table')) return;
    const hasMedia = paragraph.querySelector('img, iframe, video, picture, svg, object, embed');
    const text = (paragraph.textContent || '').replace(/\u00a0/g, ' ').trim();
    if (!hasMedia && text === '') {
      paragraph.remove();
    }
  });

  root.querySelectorAll('.article-content table').forEach((table) => {
    if (table.parentElement && table.parentElement.classList.contains('article-content__table-wrap')) return;
    const wrap = document.createElement('div');
    wrap.className = 'article-content__table-wrap';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  async function copyText(text) {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
  }

  function showTemporaryLabel(button, label) {
    const original = button.textContent;
    button.textContent = label;
    window.setTimeout(() => {
      button.textContent = original;
    }, 2000);
  }

  function canNativeShare() {
    return navigator.share && window.matchMedia('(max-width: 980px), (pointer: coarse)').matches;
  }

  root.querySelectorAll('[data-share-instagram]').forEach((button) => {
    button.addEventListener('click', async () => {
      const url = button.getAttribute('data-share-url') || window.location.href;
      const title = button.getAttribute('data-share-title') || document.title;

      if (canNativeShare()) {
        try {
          await navigator.share({ title, text: title, url });
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
      }

      await copyText(url);
    });
  });

  root.querySelectorAll('[data-copy-link]').forEach((button) => {
    button.addEventListener('click', async () => {
      const url = button.getAttribute('data-copy-link') || window.location.href;
      const copiedLabel = button.getAttribute('data-copied-label');

      await copyText(url);

      if (copiedLabel) {
        showTemporaryLabel(button, copiedLabel);
      }
    });
  });
})();
